var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.025 33.3468C23.3937 33.8645 18.6066 33.8645 13.9753 33.3468C12.2365 33.1525 10.71 32.2122 9.74442 30.8466L21.7501 18.841L25.4546 22.5454C25.894 22.9848 26.6063 22.9848 27.0456 22.5454C27.4849 22.1061 27.4849 21.3939 27.0456 20.9545L22.5456 16.4545C22.1062 16.0152 21.394 16.0152 20.9547 16.4545L8.78142 28.6276C8.74782 28.4633 8.72082 28.2964 8.70102 28.1272C8.14722 23.3919 8.14722 18.6081 8.70102 13.8727C9.02337 11.1172 11.2357 8.95932 13.9753 8.65302C18.6066 8.13552 23.3937 8.13552 28.025 8.65302C30.7646 8.95932 32.9769 11.1172 33.2992 13.8727C33.8531 18.6081 33.8531 23.3919 33.2992 28.1272C32.9769 30.8827 30.7646 33.0407 28.025 33.3468Z",
    fill: "#B51D1D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_472_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3469 13.9751C33.8645 18.6065 33.8645 23.3936 33.3469 28.0248C33.1526 29.7636 32.2122 31.2902 30.8466 32.2557L18.8411 20.25L22.5455 16.5455C22.9848 16.1062 22.9848 15.3938 22.5455 14.9545C22.1061 14.5152 21.3939 14.5152 20.9546 14.9545L16.4546 19.4546C16.0152 19.8939 16.0152 20.6061 16.4546 21.0455L28.6277 33.2187C28.4633 33.2523 28.2964 33.2793 28.1273 33.2991C23.3919 33.8529 18.6081 33.8529 13.8728 33.2991C11.1173 32.9768 8.95938 30.7644 8.65308 28.0248C8.13558 23.3936 8.13558 18.6065 8.65308 13.9751C8.95938 11.2355 11.1173 9.02318 13.8728 8.70091C18.6081 8.14706 23.3919 8.14706 28.1273 8.70091C30.8827 9.02318 33.0407 11.2355 33.3469 13.9751Z",
    fill: "#B51D1D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 14,
    width: 15,
    height: 15,
    fill: "#B51D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1074 26.8925L26.8925 15.1074",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1074 15.1074L26.8925 26.8925",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(39 39) rotate(-180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_472_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(39 3) rotate(90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteWeb);
export default __webpack_public_path__ + "static/media/inviteWeb.227120717f6777bcb33f2a916b18ef63.svg";
export { ForwardRef as ReactComponent };